export const SET_STATE = 'SET_STATE';
export const SET_SERVICE_CATEGORIES = 'SET_SERVICE_CATEGORIES';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_REGIONS = 'SET_REGIONS';
export const SET_COMPANIES = 'SET_COMPANIES';
export const SET_STEP = 'SET_STEP';
